import * as Specular$dInternal$dIncremental$dRef from "../Specular.Internal.Incremental.Ref/index.js";
const stabilizationIsNotInProgress = -1;
const globalTotalRefcount = /* #__PURE__ */ Specular$dInternal$dIncremental$dRef.new(0);
const globalLastStabilizationNum = /* #__PURE__ */ Specular$dInternal$dIncremental$dRef.new(0);
const globalCurrentStabilizationNum = /* #__PURE__ */ Specular$dInternal$dIncremental$dRef.new(-1);
export {globalCurrentStabilizationNum, globalLastStabilizationNum, globalTotalRefcount, stabilizationIsNotInProgress};
